import {Helmet} from "react-helmet-async";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import ContentContainer from "@/components/layout/ContentContainer.tsx";

export const CancelSubscriptionDone = () => {
  const {brand} = useCurrentUserContext();
  return (
    <ContentContainer title="Cancellation Request Received">
      <Helmet>
        <title>Cancellation Request Received</title>
      </Helmet>
      <div className="row">
        <div className="col-6">
          <p>
            One of our representatives will reach out regarding your cancellation shortly.
            <br />
            Please look out for an email from <a href={`mailto:${brand.email}`}>{brand.email}</a>
          </p>
        </div>
      </div>
    </ContentContainer>
  );
};
